import React from "react";
import { Link } from "gatsby";
import { loadOaiqPixel } from "../../utils/oaiq";
import { loadMetaPixel } from "../../utils/metaPixel";

const STORAGE_KEY = "tnsCookieConsent";

// Aktualizuje stan zgody w Google Consent Mode (gtag jest już w <head>)
const updateConsent = (analytics) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: analytics ? "granted" : "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
  }
};

const CookieConsent = () => {
  const [visible, setVisible] = React.useState(false);
  const [customizing, setCustomizing] = React.useState(false);
  const [analytics, setAnalytics] = React.useState(false);
  const [marketing, setMarketing] = React.useState(false);

  React.useEffect(() => {
    let decided = false;
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const c = JSON.parse(raw);
        if (c && typeof c.analytics === "boolean") {
          decided = true;
          setAnalytics(c.analytics);
          setMarketing(!!c.marketing);
          // przy powrocie z wcześniejszą zgodą marketingową - załaduj piksele
          if (c.marketing) {
            loadOaiqPixel();
            loadMetaPixel();
          }
        }
      }
    } catch (e) {
      decided = false;
    }
    if (!decided) setVisible(true);

    // "Ustawienia cookies" w stopce otwiera panel ponownie
    window.tnsCookieSettings = () => {
      setCustomizing(true);
      setVisible(true);
    };
  }, []);

  const persist = (analyticsValue, marketingValue) => {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        analytics: analyticsValue,
        marketing: marketingValue,
        ts: Date.now(),
      })
    );
    setAnalytics(analyticsValue);
    setMarketing(marketingValue);
    updateConsent(analyticsValue);
    if (marketingValue) {
      loadOaiqPixel();
      loadMetaPixel();
    }
    setVisible(false);
    setCustomizing(false);
  };

  const acceptAll = () => persist(true, true);
  const rejectAll = () => persist(false, false);
  const savePreferences = () => persist(analytics, marketing);

  if (!visible) return null;

  return (
    <div
      className="tns-cookies"
      role="dialog"
      aria-label="Zgoda na pliki cookies"
    >
      {!customizing ? (
        <>
          <div className="tns-cookies-text">
            <h6>Szanujemy Twoją prywatność</h6>
            <p>
              Używamy plików cookies do analizy ruchu i pomiaru skuteczności
              reklam. Uruchamiają się dopiero po Twojej zgodzie. Szczegóły w{" "}
              <Link to={`/polityka-prywatnosci/`} rel="nofollow">
                Polityce prywatności
              </Link>
              .
            </p>
          </div>
          <div className="tns-cookies-actions">
            <button
              type="button"
              className="tns-cookies-link"
              onClick={() => setCustomizing(true)}
            >
              Dostosuj
            </button>
            <button
              type="button"
              className="tns-cookies-link"
              onClick={rejectAll}
            >
              Odrzuć wszystko
            </button>
            <button type="button" className="butn bord" onClick={acceptAll}>
              <span>Akceptuj wszystko</span>
            </button>
          </div>
        </>
      ) : (
        <div className="tns-cookies-panel">
          <h6>Dostosuj zgody na cookies</h6>

          <div className="tns-cookie-cat">
            <div className="tns-cookie-cat-head">
              <span className="tns-cookie-cat-name">Niezbędne</span>
              <span className="tns-cookie-always">Zawsze aktywne</span>
            </div>
            <p>
              Wymagane do podstawowego działania strony, w tym do zapamiętania
              Twojego wyboru dotyczącego cookies. Nie przechowują danych
              umożliwiających identyfikację.
            </p>
          </div>

          <div className="tns-cookie-cat">
            <div className="tns-cookie-cat-head">
              <span className="tns-cookie-cat-name">Analityczne</span>
              <label className="tns-switch">
                <input
                  type="checkbox"
                  checked={analytics}
                  onChange={(e) => setAnalytics(e.target.checked)}
                />
                <span className="tns-switch-slider"></span>
              </label>
            </div>
            <p>
              Google Analytics 4 - pomaga zrozumieć, jak odwiedzający korzystają
              ze strony (liczba wizyt, źródła ruchu, popularne treści). Dane są
              zbierane w formie zanonimizowanej.
            </p>
          </div>

          <div className="tns-cookie-cat">
            <div className="tns-cookie-cat-head">
              <span className="tns-cookie-cat-name">Marketingowe</span>
              <label className="tns-switch">
                <input
                  type="checkbox"
                  checked={marketing}
                  onChange={(e) => setMarketing(e.target.checked)}
                />
                <span className="tns-switch-slider"></span>
              </label>
            </div>
            <p>
              OpenAI Ads Pixel oraz Meta Pixel (Facebook) - mierzą skuteczność
              kampanii reklamowych (np. czy odwiedziny prowadzą do kontaktu). Bez
              zgody piksele się nie uruchamiają.
            </p>
          </div>

          <div className="tns-cookies-actions">
            <button
              type="button"
              className="tns-cookies-link"
              onClick={rejectAll}
            >
              Odrzuć wszystko
            </button>
            <button
              type="button"
              className="tns-cookies-link"
              onClick={savePreferences}
            >
              Zapisz preferencje
            </button>
            <button type="button" className="butn bord" onClick={acceptAll}>
              <span>Akceptuj wszystko</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CookieConsent;
